<template>
  <div>
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="onPullRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="getList"
      >
        <div class="my-order-page">
          <OrderCard
            v-for="(item, index) in list"
            :key="index"
            :value="item || {}"
          />
          <div
            v-if="!list.length"
            class="my-blank"
          >
            <Blank text="暂无订单" />
          </div>
        </div>
      </van-list>

    </van-pull-refresh>
  </div>
</template>

<script>
import OrderCard from './components/OrderCard.vue';
import { queryMyOrder } from '@/common/api.js';
import Blank from './components/Blank.vue';
import tokenMixin from './mixins/tokenMixin.js';

class CreateQuery {
  pageSize = 10
  pageNum = 1
}

export default {
  name: 'MyOrder',
  components: {
    OrderCard,
    Blank
  },
  mixins: [tokenMixin],
  data() {
    return {
      list: [],
      loading: false,
      finished: true,
      showPullRefreshLoading: false,
      query: new CreateQuery()
    };
  },
  mounted() {
    this.onPullRefresh();
  },
  methods: {
    onPullRefresh() {
      this.query = new CreateQuery();
      this.list = [];
      this.showPullRefreshLoading = false;
      this.finished = true;
      this.$nextTick(() => {
        this.getList();
      });
    },
    getList() {
      this.loading = true;
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      queryMyOrder(this.query)
        .then((res) => {
          if (res) {
            this.list = this.list.concat(res.list || []);
            ++this.query.pageNum;
            if (!res.total || this.list.length >= res.total) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          } else {
            this.finished = true;
          }
          this.$toast.clear();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.my-order-page {
  box-sizing: border-box;
  min-height: 100vh;
  background: #f7f7f7;
  padding: 16px 32px;

  .my-blank {
    transform: translateY(30vh);
  }
}
</style>
